<template>
  <el-dialog
    title="浏览资讯"
    :visible.sync="dialogVisible"
    width="800px"
    center
    >
    <div class="box">
      <h3>{{ details.title }}</h3>
      <p class='flex-ct'>
        <!-- <i class="el-icon-date"></i> -->
        <span>{{ details.created_at }}</span>
       <!-- <i class="el-icon-user"></i>
        <span>{{ details.created_user }}</span> -->
      </p>
      <template v-if="details.is_external_web == 1">
        <div style="margin-bottom: 20px;color: #b5b5b5;">tips：本文为外链资讯</div>
        <iframe :src="details.external_web_link" style="width: 100%;height: 600px;"></iframe>
      </template>
      <div class="richText" v-else v-html="details.content"></div>
      
    </div>
    
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  import { upload } from '@/api/upload';
  export default {
    data() {
      return {
        dialogVisible: false,
        details: ''
      }
    },
    methods: {
      show(row){
        userInfoAPI.detailInformation(row.id).then(({ data })=>{
          if (data.code == 0) {
            this.details = data.data
            this.dialogVisible = true
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            });
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  h3,p{
    text-align: center;
  }
  p{
    margin: 30px 0;
    color: #999;
  }
  .el-icon-date,.el-icon-user{
    margin-right: 10px;
    font-size: 14px;
  }
  .el-icon-user{
    margin-left: 50px;
  }
  /deep/ .richText{
    img{
      max-width: 100%;
    }
  }
</style>